module.exports = __webpack_public_path__ + "static/postgresql-794ff5f8295f0992848b86ff4ee6652a.svg";